var _circle, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobliedown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    stroke: "#404040"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 25.6667V21",
    stroke: "#404040",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23.6667L27 25.6667L29 23.6667",
    stroke: "#404040",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3327 27H24.666",
    stroke: "#404040",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.07 8H10.93C10.3901 8.03793 9.8849 8.32349 9.524 8.79465C9.16311 9.26581 8.97571 9.88451 9.00253 10.5164V25.4836C8.97571 26.1155 9.16311 26.7342 9.524 27.2053C9.8849 27.6765 10.3901 27.9621 10.93 28H19.07C19.6099 27.9621 20.1151 27.6765 20.476 27.2053C20.8369 26.7342 21.0243 26.1155 20.9975 25.4836V10.5164C21.0243 9.88451 20.8369 9.26581 20.476 8.79465C20.1151 8.32349 19.6099 8.03793 19.07 8ZM20.137 25.4836C20.1633 25.8485 20.0663 26.2109 19.8668 26.4932C19.6674 26.7754 19.3813 26.955 19.07 26.9935H10.93C10.6187 26.955 10.3326 26.7754 10.1332 26.4932C9.93373 26.2109 9.83674 25.8485 9.863 25.4836V10.5164C9.83674 10.1515 9.93373 9.78906 10.1332 9.50683C10.3326 9.2246 10.6187 9.045 10.93 9.00654H12.2465V9.51988C12.2465 9.78683 12.3372 10.0428 12.4985 10.2316C12.6599 10.4204 12.8788 10.5264 13.107 10.5264H16.893C17.1212 10.5264 17.3401 10.4204 17.5015 10.2316C17.6628 10.0428 17.7535 9.78683 17.7535 9.51988V9.00654H19.07C19.3813 9.045 19.6674 9.2246 19.8668 9.50683C20.0663 9.78906 20.1633 10.1515 20.137 10.5164V25.4836Z",
    fill: "#404040"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 24.9341H17C17.1326 24.9341 17.2598 24.8814 17.3536 24.7876C17.4473 24.6939 17.5 24.5667 17.5 24.4341C17.5 24.3015 17.4473 24.1743 17.3536 24.0805C17.2598 23.9868 17.1326 23.9341 17 23.9341H13C12.8674 23.9341 12.7402 23.9868 12.6464 24.0805C12.5527 24.1743 12.5 24.3015 12.5 24.4341C12.5 24.5667 12.5527 24.6939 12.6464 24.7876C12.7402 24.8814 12.8674 24.9341 13 24.9341Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobliedown);
export default __webpack_public_path__ + "static/media/mobliedown.ce8cf5dd78f0125483d04cc2bde4546f.svg";
export { ForwardRef as ReactComponent };